import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div>
              <img 
                src="https://static.readdy.ai/image/036fbfb6a6a84f25228dac0e3f2f7322/ff016c665b509abee080a033986c8f8e.png" 
                alt="Stratis Advisory" 
                className="h-12 mb-4"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Strategic consulting for financial services. Helping banks, insurers, and fintechs navigate regulatory landscapes and execute strategic transformations.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-gray-300 hover:text-white cursor-pointer">IGNITE REGULATORY</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white cursor-pointer">IGNITE EXECUTION</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white cursor-pointer">IGNITE LAUNCH</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white cursor-pointer">IGNITE CX</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white cursor-pointer">Contact</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Stratis Advisory. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
